// router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import HOME from '@/components/Home'
import FCHQ from '@/components/fchq'
import TENNIS from '@/components/tennis'
import FUTSAL from '@/components/futsal'
import WHITLAM from '@/components/whitlam'
import WHITLAMCALENDAR from '@/components/whitlam-calendar'

const routes = [
    {
        path: '/bookingapp/',
        name: 'HOME',
        component: HOME
    },
    {
        path: '/bookingapp/fchq',
        name: 'FCHQ',
        component: FCHQ
    },
    {
        path: '/bookingapp/tennis',
        name: 'tennis',
        component: TENNIS
    },
    {
        path: '/bookingapp/futsal',
        name: 'futsal',
        component: FUTSAL
    },
    {
        path: '/bookingapp/whitlam',
        name: 'whitlam',
        component: WHITLAM
    },
    {
        path: '/bookingapp/whitlam/:page',
        name: 'whitlam-rooms',
        component: WHITLAM
    },
    {
        path: '/bookingapp/whitlam-calendar',
        name: 'whitlam-calendar',
        component: WHITLAMCALENDAR
    },
    {
        path: '/bookingapp/whitlam-calendar/:page',
        name: 'whitlam-calendar-rooms',
        component: WHITLAMCALENDAR
    }
]

const router = createRouter({
    mode: 'history',
    base: '/bookingapp/',
    history: createWebHistory(),
    routes
})
export default router